import { render, staticRenderFns } from "./ShowGroups.vue?vue&type=template&id=048a4bc0&"
import script from "./ShowGroups.vue?vue&type=script&lang=js&"
export * from "./ShowGroups.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports